interface ProjectBodyProps {
  content: string;
}

const ProjectBody = ({ content }: ProjectBodyProps) => {
  return (
    <div data-component-id="src/app/project-detail/components/ProjectBody.tsx:7:4" data-component-path="src/app/project-detail/components/ProjectBody.tsx" data-component-line="7" data-component-end-line="12" data-component-file="ProjectBody.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22prose%20prose-lg%20max-w-none%22%7D" className="prose prose-lg max-w-none">
      <div data-component-id="src/app/project-detail/components/ProjectBody.tsx:8:6" data-component-path="src/app/project-detail/components/ProjectBody.tsx" data-component-line="8" data-component-end-line="11" data-component-file="ProjectBody.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-foreground%22%7D"
        className="text-foreground"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default ProjectBody;